import {Base} from "@/api/Base"

export class CurrencyList extends Base {
    path = "currency/list"
}